import { GrowthBook } from '@growthbook/growthbook-react';

// see growthbook docs to set and use feature flag
//
const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: process.env.GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: process.env.GROWTH_BOOK_DEV_MODE == 'true',
  subscribeToChanges: true,
  trackingCallback: () => {
    // TODO: Use your real analytics tracking system
  },
});

export default growthbook;
